import CustomTooltip from 'components/CustomTooltip'

type TooltipProps = {
  children: React.ReactNode
  tooltipText: string
}
export const Tooltip = ({ children, tooltipText }: TooltipProps) => {
  return (
    <CustomTooltip
      tooltipText={tooltipText}
      contentProps={{ side: 'right', sideOffset: 15 }}
    >
      {children}
    </CustomTooltip>
  )
}
